import React from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import layout from "../../../actprep-ui/constants/layout";
import MasterSheet from "../../../components/MasterSheet";
import useFilters from "../../../actprep-ui/hooks/ui/useFilters";
import { masterSheetFilters } from "../../../constants/filters";
import { Box, Chip, Drawer } from "@mui/material";
import useDisclosure from "../../../actprep-ui/hooks/ui/useDisclosure";
import { Tune } from "@mui/icons-material";

export default function Master() {
  const filtersDisc = useDisclosure();
  const { getFilterParams, FiltersAppliedList, Filters } = useFilters({
    name: "Master Sheet Filters",
    filtersConfig: masterSheetFilters,
    handleClose: filtersDisc.onClose,
  });
  return (
    <>
      <Drawer anchor="right" {...filtersDisc.getDisclosureProps()}>
        <Box
          sx={{ paddingTop: `${layout.navBarHeight + 1}rem`, width: "25rem" }}
        >
          <Filters />
        </Box>
      </Drawer>
      <Grid
        sx={{
          mt: `${layout.navBarHeight + 1}rem`,
          mb: 4,
        }}
        size={12}
      >
        <Typography variant="h5" fontWeight={"bold"} my={2} color={"primary"}>
          <span>Master Sheet</span>{" "}
          <Chip
            {...filtersDisc.getButtonProps()}
            label="Filters"
            icon={<Tune />}
            size="small"
          />
        </Typography>
        <FiltersAppliedList />
        <MasterSheet filters={getFilterParams()} />
      </Grid>
    </>
  );
}
